import { render, staticRenderFns } from "./GameStatusAndPopover.vue?vue&type=template&id=2ba3a657&scoped=true&"
import script from "./GameStatusAndPopover.vue?vue&type=script&lang=js&"
export * from "./GameStatusAndPopover.vue?vue&type=script&lang=js&"
import style0 from "./GameStatusAndPopover.vue?vue&type=style&index=0&id=2ba3a657&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3a657",
  null
  
)

export default component.exports